const ENDPOINT = process.env.GRAPHQL_ENDPOINT || '/graphql';

function getToken(): string | null {
  try {
    return localStorage.getItem('console_token');
  } catch {
    return null;
  }
}

export function setToken({ token }: { token: string }): void {
  localStorage.setItem('console_token', token);
}

export function clearToken(): void {
  localStorage.removeItem('console_token');
}

export async function gql<T = any>({
  query,
  variables,
}: {
  query: string;
  variables?: Record<string, any>;
}): Promise<T> {
  const token = getToken();
  const headers: Record<string, string> = {
    'content-type': 'application/json',
  };
  if (token) {
    headers['authorization'] = `Bearer ${token}`;
  }

  const res = await fetch(ENDPOINT, {
    method: 'POST',
    headers,
    body: JSON.stringify({ query, variables }),
  });

  const json = await res.json();
  if (json.errors?.length) {
    const message = json.errors[0].message as string;
    if (message === 'Forbidden') {
      window.dispatchEvent(new CustomEvent('session-expired'));
    }
    throw new Error(message);
  }
  return json.data as T;
}
